import { Typography, Grid } from '@mui/material';
import React from 'react';
import {
    StyPaper,
    StyLoadingSkeleton,
    StyBlock,
    StyCenterdTypography,
} from './StyledComponents';
import { useTranslation } from 'react-i18next';

const TbiCalculation = ({
    isLoading,
    newMajoredIndex,
    gradeSalary,
}: {
    isLoading: boolean;
    newMajoredIndex: string;
    gradeSalary: number;
}): React.ReactElement => {
    const { t } = useTranslation();
    return (
        <StyPaper>
            <StyBlock>
                <Typography variant="h5" color="primary">
                    {t(
                        'humanResources.simulation.gradeHypothesis.tbiCalculation',
                    )}
                </Typography>
                <Grid
                    container
                    spacing={4}
                    sx={{ paddingTop: '24px', gap: '2em' }}
                >
                    <Grid
                        item
                        xs={5}
                        direction="row"
                        display="flex"
                        sx={{ gap: '2em' }}
                    >
                        <StyCenterdTypography variant="body1">
                            {t(
                                'humanResources.simulation.gradeHypothesis.newMajoredIndex',
                            )}
                        </StyCenterdTypography>
                        {isLoading ? (
                            <StyLoadingSkeleton />
                        ) : (
                            <StyCenterdTypography
                                variant="body1"
                                color="primary"
                            >
                                {newMajoredIndex}
                            </StyCenterdTypography>
                        )}
                    </Grid>
                    {newMajoredIndex && (
                        <Grid
                            item
                            xs={6}
                            direction="row"
                            display="flex"
                            sx={{ gap: '2em' }}
                        >
                            <StyCenterdTypography
                                variant="body1"
                                sx={{ display: 'flex', alignItems: 'center' }}
                            >
                                {t(
                                    'humanResources.simulation.gradeHypothesis.newTbi',
                                )}
                            </StyCenterdTypography>
                            {isLoading ? (
                                <StyLoadingSkeleton />
                            ) : (
                                <StyCenterdTypography
                                    variant="body1"
                                    color="primary"
                                >
                                    {t(
                                        'humanResources.simulation.gradeHypothesis.brutSalary',
                                        { salary: gradeSalary },
                                    )}
                                </StyCenterdTypography>
                            )}
                        </Grid>
                    )}
                </Grid>
            </StyBlock>
        </StyPaper>
    );
};

export default TbiCalculation;
